/**
 * 渲染方式基类
 */
export class Renderer {
}
